<!--
 * @Description: 
 * @Author: HG
 * @Date: 2019-08-21 13:38:08
 * @LastEditors: mojiangpeng 125392435@qq.com
 * @LastEditTime: 2023-12-11 13:51:32
 -->
<template>
  <div class="container">
    <div class="member-header">
      <van-swipe
        ref="swipe"
        @change="swipeOnChange"
        class="my-swipe"
        indicator-color="white"
        v-if="hasPeople"
      >
        <van-swipe-item v-for="(item, index) in allUser" :key="index"
          ><div class="flex member-info">
            <div class="flex avatar" @click="toInfo(item)">
              <img
                class="avatar-img"
                v-if="item.wxHeadImgUrl"
                :src="item.wxHeadImgUrl"
                alt
              />
              <span class="avatar-img" v-else>{{ lastName }}</span>
            </div>
            <div class="info" @click="toInfo(item)">
              <div class="name">
                {{ item.cardholderName }}
                <p class="diagnosisCardNo">{{ currentUser.diagnosisCardNo }}</p>
              </div>
            </div>
            <div class="codeImg" @click="showCode(true)">
              <div class="imgBox">
                <img src="/images/code.png" alt="" />
              </div>

              <p>刷卡时出示</p>
            </div>
          </div></van-swipe-item
        >
      </van-swipe>
    </div>
    <div class="kong"></div>
    <van-cell-group>
      <van-cell title="就诊卡管理" size="large" is-link to="/user/contact/list">
        <span slot="icon" class="cell-icon" style="color: #07c160">
          <van-icon name="card" />
        </span>
      </van-cell>
      <van-cell
        title="自助办理电子健康卡"
        size="large"
        is-link
        to="/user/contact/addCard"
        v-if="Setting.enabledMobileSelfCreateCard"
      >
        <span slot="icon" class="cell-icon" style="color: #f44336">
          <van-icon name="card" />
        </span>
      </van-cell>
      <van-cell
        v-if="
          Setting.enabledMobileTodayRegistration ||
            Setting.enabledMobileBookingRegistration
        "
        title="我的挂号"
        size="large"
        is-link
        to="/user/order/list"
      >
        <span slot="icon" class="cell-icon" style="color: #1989fa">
          <i class="iconfont icon-guahao"></i>
        </span>
      </van-cell>
      <van-cell
        title="我的住院"
        size="large"
        is-link
        to="/user/inHospital/Index"
        v-if="Setting.enabledMobileMyInHospital"
      >
        <span slot="icon" class="cell-icon" style="color: #ff976a">
          <i class="iconfont icon-zhuyuan"></i>
        </span>
      </van-cell>
      <van-cell
        title="我的账单"
        v-if="Setting.enabledMobileMyBills"
        size="large"
        is-link
        to="/user/bill/list"
      >
        <span slot="icon" class="cell-icon" style="color: #1989fa">
          <i class="iconfont icon-money-order"></i>
        </span>
      </van-cell>

      <van-cell
        v-if="Setting.enabledMobileMyReport"
        title="我的报告"
        size="large"
        is-link
        to="/user/report/list"
      >
        <span slot="icon" class="cell-icon" style="color: #f44336">
          <i class="iconfont icon-book"></i>
        </span>
      </van-cell>
      <van-cell
        v-if="Setting.enabledElectricBill"
        title="我的电子票"
        size="large"
        is-link
        to="/electricBill/List"
      >
        <span slot="icon" class="cell-icon" style="color: #f44336">
          <van-icon name="coupon-o" size="17px" />
        </span>
      </van-cell>
    </van-cell-group>
    <div class="kong"></div>
    <!-- <van-cell-group>
      <van-cell title="设置" size="large" is-link to="index">
        <span slot="icon" class="cell-icon" style="color:#c73075"
          ><van-icon name="setting"
        /></span>
      </van-cell>
    </van-cell-group>-->

    <van-overlay :show="showCodeFlag" @click="showCode(false)">
      <div class="wrapper">
        <div class="qrcodeBox" @click.stop>
          <div class="topBox">出示二维码</div>
          <van-tabs v-model="tabActive" ref="tabs">
            <van-tab
              v-if="Setting.displayCasehistoryNo"
              title="门诊号"
              style="paddingtop: 8px"
            >
              <qrcode
                v-if="currentUser.caseHistoryNo"
                :value="currentUser.caseHistoryNo"
                :options="{ size: 150 }"
              ></qrcode>
              <p>{{ currentUser.caseHistoryNo }}</p>
            </van-tab>
            <van-tab
              v-if="currentUser.diagnosisCardNo"
              title="就诊卡"
              style="paddingtop: 8px"
            >
              <qrcode
                v-if="currentUser.diagnosisCardNo"
                :value="currentUser.diagnosisCardNo"
                :options="{ size: 150 }"
              ></qrcode>
              <p>{{ currentUser.diagnosisCardNo }}</p>
            </van-tab>
            <van-tab
              title="电子健康码"
              style="paddingtop: 8px"
              v-if="currentUser.qrCodeText"
            >
              <qrcode
                v-if="currentUser.qrCodeText"
                :value="currentUser.qrCodeText"
                :options="{ size: 150 }"
              ></qrcode>
              <!-- <p>{{ currentUser.qrCodeText }}</p> -->
            </van-tab>
          </van-tabs>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
// import { mapState, mapActions } from "vuex";
import {
  Button,
  Icon,
  Cell,
  CellGroup,
  Swipe,
  SwipeItem,
  Overlay,
  Tab,
  Tabs,
} from "vant"
import ContactPicker from "@/components/contact-picker"
import { cache } from "@/utils/common"
import VueQrcode from "@xkeshi/vue-qrcode"

export default {
  name: "userIndex",
  components: {
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Button.name]: Button,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Overlay.name]: Overlay,
    [VueQrcode.name]: VueQrcode,
  },
  data() {
    return {
      showCodeFlag: false,
      info: {},
      Setting: {},
      ContactPickerModal: "",
      allUser: [],
      currentUser: {},
      hasPeople: true,
      tabActive: 0,
    }
  },
  created() {
    const that = this
    that.$post("GetWxSystemParameterInfo", {}).then((res) => {
      const userInfo = cache.get("user")
      cache.set("user", { ...userInfo, ...res.data })
      that.Setting = cache.get("user")
      const contact = cache.get("currentContact")
      that.currentUser = contact ? contact : {}
      that.Setting.enabledMobileTodayRegistration = true
      //获取联系人列表
      that.$post("Contact_List").then((res) => {
        that.allUser = res.data.datas
        if (that.allUser && that.allUser.length) {
          that.hasPeople = true
          if (contact && contact.id) {
            const index = that.allUser.findIndex((p) => p.id === contact.id)
            if (
              that.allUser.length > 1 &&
              JSON.stringify(that.allUser[0]) !==
                JSON.stringify(that.allUser[index])
            ) {
              that.swapArray(that.allUser, 0, index)
            }
          } else {
            that.currentUser = that.allUser[0]
          }
          console.log(that.currentUser)
        } else {
          that.hasPeople = false
        }
      })
    })
  },
  mounted() {
    this.swipeTo(2)
  },
  computed: {
    // ...mapState({
    //   title: state => state.app.title
    // }),
    lastName() {
      // console.log(this.allUser[0]);
      // if (this.info && this.info.CardholderName) {
      //   const nameArr = this.info.CardholderName.split("");
      //   let lastName = "...";
      //   if (nameArr && nameArr.length) {
      //     lastName = nameArr[nameArr.length - 1];
      //   }
      //   return lastName;
      // } else {
      //   return "";
      // }
      if (this.currentUser && this.currentUser.cardholderName) {
        const nameArr = this.currentUser.cardholderName.split("")
        let lastName = "..."
        if (nameArr && nameArr.length) {
          lastName = nameArr[nameArr.length - 1]
        }
        return lastName
      } else {
        return ""
      }
    },
  },
  beforeDestroy() {
    this.ContactPickerModal && this.ContactPickerModal.cancel()
  },
  methods: {
    // 数组交换位置
    /**
     * 数组元素交换位置
     * @param {array} arr 数组
     * @param {number} index1 添加项目的位置
     * @param {number} index2 删除项目的位置
     * index1和index2分别是两个数组的索引值，即是两个要交换元素位置的索引值，如1，5就是数组中下标为1和5的两个元素交换位置
     */
    swapArray(arr, index1, index2) {
      arr[index1] = arr.splice(index2, 1, arr[index1])[0]
      return arr
    },
    // 指定轮播图显示第几张
    swipeTo(index) {
      this.$refs.swipe.swipeTo(index)
    },
    // 展示二维码
    showCode(e) {
      this.showCodeFlag = e
      this.$refs.tabs.resize()
    },
    // ...mapActions(["setTitle"]),
    // addTitle() {
    //   this.setTitle(this.i++);
    // }
    selectContact() {
      this.ContactPickerModal = ContactPicker({
        value: this.info.id,
        change: this.onContactChange,
      })
    },
    onContactChange(data) {
      const that = this
      this.allUser.forEach((item, index) => {
        if (item.Id == data.Id) {
          that.swipeTo(index)
        }
      })
    },
    swipeOnChange(data) {
      this.currentUser = this.allUser[data]
      this.$post("SetIsDefaultCard", { id: this.currentUser.id }).then()
      cache.set("currentContact", this.allUser[data], 24 * 60 * 60 * 1000)
    },
    toInfo(item) {
      console.log(item)
      this.$router.push({
        name: "userContactInfo",
        query: {
          Id: item.id,
        },
      })
    },
  },
}
</script>

<style lang="less" scoped>
.member-header {
  // padding: 1rem;
  height: 4rem;
  width: 100%;
  background-image: linear-gradient(-45deg, #63b6f8, #0f78f3);

  .member-info {
    font-size: 0.5rem;
    color: #fff;
    margin: 0.6rem 0 1rem 0.5rem;
    position: relative;
    .avatar {
      .avatar-img {
        width: 1.7rem;
        height: 1.7rem;
        border-radius: 1.7rem;
        background: rgba(255, 255, 255, 0.5);
        text-align: center;
        line-height: 1.7rem;
        font-size: 0.8rem;
      }
    }
    .action {
      padding: 0.05rem 0.2rem;
      border: 1px solid #ddd;
      font-size: 0.3rem;
      border-radius: 0.5rem;
      display: inline-block;
    }
    .info {
      margin-left: 0.3rem;
      .name {
        // line-height: 2.7;
        padding-top: 0.4rem;
        font-size: 0.6rem;
        .diagnosisCardNo {
          // line-height: 0;
          margin-top: 0.8rem;
          font-size: 0.6rem;
          letter-spacing: 0.05rem;
        }
      }
    }
    .codeImg {
      position: absolute;
      text-align: center;
      top: 30%;
      right: 1rem;
      transform: translateY(-50%);
      width: 2rem;
      height: 2rem;
      padding-top: 0.5rem;
      .imgBox {
        position: relative;
        width: 60%;
        height: 60%;
        background-color: white;
        border-radius: 0.1rem;
        margin: 0 auto;
        margin-bottom: 5px;
        img {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 90%;
          height: 90%;
        }
      }
      p {
        font-size: 0.3rem;
      }
    }
  }
}
.my-swipe {
  height: 100%;
  width: 100%;
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  .qrcodeBox {
    height: 295px;
    width: 300px;
    // padding: 20px;
    background-color: #fff;
    text-align: center;
    border-radius: 0.2rem;
    overflow: hidden;
    .topBox {
      margin-bottom: 0.2rem;
      font-size: 0.4rem;
      line-height: 30px;
      width: 100%;
      height: 30px;
      color: #fff;
      background-image: linear-gradient(-45deg, #63b6f8, #0f78f3);
    }
    p {
      font-size: 0.4rem;
    }
  }
}

/deep/.van-tabs__line {
  background-image: linear-gradient(-45deg, #63b6f8, #0f78f3) !important;
}
/deep/.van-tabs__content {
  padding-top: 20px;
}
</style>
